import React, { useState, useEffect } from "react";
import { useTheme } from "../context/ThemeContext";
import SideMenu from "./SideMenu/SideMenu";
import ThemeSwitcher from "./ThemeSwitcher/ThemeSwitcher";
import { Outlet, useLocation } from "react-router-dom";
import ProfilePicture from "./ProfilePicture.js";

const Layout = () => {
    const { themeStyles } = useTheme();
    const location = useLocation();

    const [isMobile, setIsMobile] = useState(false);
    const [sidebarOpen, setSidebarOpen] = useState(false);

    useEffect(() => {
        // Check screen width initially
        setIsMobile(window.innerWidth < 768);

        // Listen for window resize events
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener("resize", handleResize);

        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    // List of routes where the side menu should not be displayed
    const hideSideMenuRoutes = ["/"];
    const shouldShowSideMenu = !hideSideMenuRoutes.includes(location.pathname);

    // Toggle sidebar on mobile
    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    return (
        <div
            style={{
                background: themeStyles.background,
                color: themeStyles.text,
                minHeight: "100vh",
                display: isMobile ? "" : "flex",
            }}
        >
            {/* Show SideMenu only if allowed and not on small screens */}
            {shouldShowSideMenu && !isMobile && <SideMenu />}
            {isMobile && (
                <>
                    {/* Mobile Sidebar Toggle Button */}

                    {/* Mobile Sidebar */}
                    <div
                        className={`fixed top-0 left-0 h-full z-10 transition-transform duration-300 ${sidebarOpen ? "translate-x-0" : "-translate-x-full"
                            }`}
                        style={{
                            backgroundColor: themeStyles.sidebarBackgroundColor,
                        }}
                    >
                        <SideMenu toggleSidebar={toggleSidebar} isMobile={isMobile} />
                    </div>
                </>
            )}
            <div style={{ flex: 1, display: "flex", flexDirection: "column", height: "100vh", minWidth: "0" }}>
                {/* Top bar */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        gap: "10px",
                        padding: isMobile ? 0 : "20px",
                        paddingInline: "20px",
                        height: isMobile ? 80 : "60px", // Set a fixed height for the header
                        backgroundColor: isMobile ? themeStyles.sidebarBackgroundColor : "transparent",
                        flexShrink: 0,
                    }}
                >
                    {isMobile && (
                        <button
                            className="hamburger-menu"
                            onClick={toggleSidebar}
                            style={{
                                position: "absolute",
                                top: "20px",
                                left: "20px",
                                zIndex: 0,
                                background: "none",
                                border: "none",
                                fontSize: "30px",
                                color: sidebarOpen || isMobile ? '#FFF' : themeStyles.text,
                            }}
                        >
                            &#9776;
                        </button>
                    )}
                    {shouldShowSideMenu && !isMobile && <ThemeSwitcher isMobile={isMobile} />}
                    {
                        <ProfilePicture
                            isMobile={isMobile}
                            learnerName={localStorage.getItem("tutorName")}
                            profilePicUrl={
                                localStorage.getItem("userRole") === "tutor"
                                    ? localStorage.getItem("tutorProfile")
                                    : ""
                            }
                        />
                    }
                </div>

                {/* Scrollable content */}
                <div style={{ overflowY: "auto" }}>
                    <Outlet />
                </div>
            </div>

        </div>
    );
};

export default Layout;
